import { products } from "../data/products"
import { memberships } from "../data/memberships"

export const getProduct = id => products.find(product => product.id === id)
export const getMembership = id =>
  memberships.find(membership => membership.id === id)
export const getCartItem = ({ id, type }) => {
  if (!type || type === "product") {
    return getProduct(id)
  } else {
    return getMembership(id)
  }
}
